<!--基础排班课程设置-->
<template>
  <div  class="sb-container">

    <div style="width: 20%">
      <el-form  ref="registerRef"  label-width="100px" size="small">
        <el-form-item label="课程名" >
          <el-input   v-model="name" placeholder=""></el-input>
        </el-form-item>
      </el-form>
    </div>


  </div>
</template>

<style>
  .sb-container{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    height: 600px;
  }
</style>

<script>

  export default {
    name: 'SchelingBaseLessonSetting',
    props: {
      lessonName:String
    },
    data() {
      return {
        name:""
      }
    },
    created(){
      this.initData();
    },
    methods: {
      initData(){
        this.name =this.lessonName;
      },
      onGetBaseLessonName(){
        return this.name;
      }
    }
  }
</script>






// WEBPACK FOOTER //
// src/views/my-store/sw-teacher-scheduling-bs/components/SchelingBaseLessonSetting.vue